import { observer } from 'mobx-react-lite'
import PhoneCheckrModalImage from 'shared/assets/images/billing/PhoneCheckrModal.png'
import { Typography } from 'shared/ui'
import styles from './styles.module.scss'

export const PhoneCheckFirstModalContent = observer(() => {
  return (
    <div>
      <div className={styles.phoneCheckrModalTitle}>
        <Typography ariaLabel='phone_check_first_modal_title' variant='heading-lg'>
          PhoneCheckr
        </Typography>
        <Typography
          ariaLabel='phone_check_first_modal_description'
          variant='body-rg-regular'
          color='var(--content-primary-primary)'
        >
          $0.01 / lookup
        </Typography>
      </div>
      <Typography
        ariaLabel='phone_check_first_modal_description'
        variant='body-rg-regular'
        color='var(--content-primary-tertiary)'
        tag='div'
        className={styles.phoneCheckrModalDescription}
      >
        PhoneCheckr is a lookup tool that validates contacts’ phone numbers. It prevents sending
        messages to invalid numbers, thus losing credits and getting blocked by carriers.
      </Typography>

      <img src={PhoneCheckrModalImage} alt='phone_check_first_modal_image' />
    </div>
  )
})
